const MyBookingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" >
  <path fill="#706B69" d="M18.5 4h-2V2h-2v2h-6V2h-2v2h-2c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 6v10h-14V10zm-14-2V6h14v2z"/>

  <path
    d="M12 19C14.2091 19 16 17.2091 16 15C16 12.7909 14.2091 11 12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19Z"
    stroke="#FFF" stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M12 13.5V16.5M13.5 15H10.5"
    stroke="#FFF" stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
);

export default MyBookingsIcon;
